module.exports = __webpack_public_path__ + "ed015c7a8270d7d88640d47cec2d83f2.pdf";